export default __webpack_public_path__ + "98b18d6f0f81b4fe11f23e7d5148616e.glb";